// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/fonts/Poppins/Poppins-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/fonts/Poppins/Poppins-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/fonts/Poppins/Poppins-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/fonts/Poppins/Poppins-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/fonts/Poppins/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/fonts/Poppins/Poppins-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/assets/fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/assets/fonts/Poppins/Poppins-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/assets/fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/assets/fonts/Poppins/Poppins-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/src/assets/fonts/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/src/assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/assets/fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/src/assets/fonts/Poppins/Poppins-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/src/assets/fonts/Poppins/Poppins-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/src/assets/fonts/Poppins/Poppins-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/src/assets/fonts/Poppins/Poppins-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/src/assets/fonts/Poppins/Poppins-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "Poppins";
	font-weight: 100;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"),
		local("Poppins Thin"), local("Poppins-100");
}

@font-face {
	font-family: "Poppins";
	font-weight: 100;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
			format("truetype"),
		local("Poppins Thin Italic"), local("Poppins-100italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 200;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
			format("truetype"),
		local("Poppins Extra Light"), local("Poppins-200");
}

@font-face {
	font-family: "Poppins";
	font-weight: 200;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
			format("truetype"),
		local("Poppins Extra Light Italic"), local("Poppins-200italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 300;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"),
		local("Poppins Light"), local("Poppins-300");
}

@font-face {
	font-family: "Poppins";
	font-weight: 300;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
			format("truetype"),
		local("Poppins Light Italic"), local("Poppins-300italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 400;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype"),
		local("Poppins Regular"), local("Poppins-400");
}

@font-face {
	font-family: "Poppins";
	font-weight: 400;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype"),
		local("Poppins Regular Italic"), local("Poppins-400italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 500;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"),
		local("Poppins Medium"), local("Poppins-500");
}

@font-face {
	font-family: "Poppins";
	font-weight: 500;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
			format("truetype"),
		local("Poppins Medium Italic"), local("Poppins-500italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 600;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"),
		local("Poppins Semi-Bold"), local("Poppins-600");
}

@font-face {
	font-family: "Poppins";
	font-weight: 600;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
			format("truetype"),
		local("Poppins Semi-Bold Italic"), local("Poppins-600italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 700;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype"),
		local("Poppins Bold"), local("Poppins-700");
}

@font-face {
	font-family: "Poppins";
	font-weight: 700;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_13___})
			format("truetype"),
		local("Poppins Bold Italic"), local("Poppins-700italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 800;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"),
		local("Poppins Extra Bold"), local("Poppins-800");
}

@font-face {
	font-family: "Poppins";
	font-weight: 800;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_15___})
			format("truetype"),
		local("Poppins Extra Bold Italic"), local("Poppins-800italic");
}

@font-face {
	font-family: "Poppins";
	font-weight: 900;
	font-style: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"),
		local("Poppins Black"), local("Poppins-900");
}

@font-face {
	font-family: "Poppins";
	font-weight: 900;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_17___})
			format("truetype"),
		local("Poppins Black Italic"), local("Poppins-900italic");
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/Poppins/fonts.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;6CAC4C;AAC7C;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;0DAEyD;AAC1D;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;oDAEmD;AACpD;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;iEAEgE;AACjE;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;8CAC6C;AAC9C;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;2DAE0D;AAC3D;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;gDAC+C;AAChD;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;6DAC4D;AAC7D;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;+CAC8C;AAC/C;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;4DAE2D;AAC5D;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;kDACiD;AAClD;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;+DAE8D;AAC/D;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;6CAC4C;AAC7C;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;0DAEyD;AAC1D;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;mDACkD;AACnD;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;gEAE+D;AAChE;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;8CAC6C;AAC9C;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB;;2DAE0D;AAC3D","sourcesContent":["@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 100;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-Thin.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Thin\"), local(\"Poppins-100\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 100;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-ThinItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Thin Italic\"), local(\"Poppins-100italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 200;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-ExtraLight.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Extra Light\"), local(\"Poppins-200\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 200;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-ExtraLightItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Extra Light Italic\"), local(\"Poppins-200italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 300;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-Light.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Light\"), local(\"Poppins-300\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 300;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-LightItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Light Italic\"), local(\"Poppins-300italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 400;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-Regular.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Regular\"), local(\"Poppins-400\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 400;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-Italic.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Regular Italic\"), local(\"Poppins-400italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 500;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-Medium.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Medium\"), local(\"Poppins-500\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 500;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-MediumItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Medium Italic\"), local(\"Poppins-500italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 600;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-SemiBold.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Semi-Bold\"), local(\"Poppins-600\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 600;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Semi-Bold Italic\"), local(\"Poppins-600italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 700;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-Bold.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Bold\"), local(\"Poppins-700\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 700;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-BoldItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Bold Italic\"), local(\"Poppins-700italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 800;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-ExtraBold.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Extra Bold\"), local(\"Poppins-800\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 800;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-ExtraBoldItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Extra Bold Italic\"), local(\"Poppins-800italic\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 900;\n\tfont-style: normal;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-Black.ttf\") format(\"truetype\"),\n\t\tlocal(\"Poppins Black\"), local(\"Poppins-900\");\n}\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-weight: 900;\n\tfont-style: italic;\n\tsrc: url(\"/src/assets/fonts/Poppins/Poppins-BlackItalic.ttf\")\n\t\t\tformat(\"truetype\"),\n\t\tlocal(\"Poppins Black Italic\"), local(\"Poppins-900italic\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
